/**
 * Shared count phrasing.
 *
 * These sentences appeared in three places with three different pluralization
 * behaviors — "1 takes from 1 people so far" was reachable on the very screen
 * that greets a guest whose take is the first one in a moment. Counting copy is
 * exactly the kind of string that looks trivial and then reads as broken to the
 * one user who hits the singular case.
 */

/** "6 takes" / "1 take" */
export function takeCount(takes: number): string {
  return `${takes} ${takes === 1 ? 'take' : 'takes'}`;
}

/** "5 people" / "1 person" */
export function personCount(people: number): string {
  return `${people} ${people === 1 ? 'person' : 'people'}`;
}

/**
 * "6 takes from 5 people so far" — no comma, per the OurTake voice ruling.
 * "1 take from 1 person so far" in the singular.
 */
export function chorusCount(takes: number, people: number): string {
  return `${takeCount(takes)} from ${personCount(people)} so far`;
}

/** "6 takes so far" / "1 take so far" — the count-only variant. */
export function takesSoFar(takes: number): string {
  return `${takeCount(takes)} so far`;
}
